<form clrStepper [formGroup]="transportForm" >
  <clr-stepper-panel formGroupName="stepI">
    <clr-step-title>Empfänger</clr-step-title>
    <clr-step-description>Name, Kurzbeschreibung, Zeitraum</clr-step-description>
    <clr-step-content *clrIfExpanded>

      <app-request-company-search (submitSupplierNumber)="preFillRow($event)"></app-request-company-search>

      <clr-input-container>
        <label>Firma</label>
        <input clrInput name="company_name" formControlName="company_name" />
      </clr-input-container>
      <clr-input-container>
        <label>Straße</label>
        <input clrInput formControlName="street" />
      </clr-input-container>
      <clr-input-container>
        <label>Stadt</label>
        <input clrInput formControlName="city" />
      </clr-input-container>
      <clr-input-container>
        <label>PLZ</label>
        <input clrInput formControlName="postcode" />
      </clr-input-container>
      <app-country-select controlName="country" label="Land" />
      <clr-select-container *ngIf="isUpdateMode">
        <label>Status</label>
        <select clrSelect formControlName="status" required>
          <option value="running">In Arbeit</option>
          <option value="waiting">Wartet auf Abholung</option>
          <option value="ontour">On Tour</option>
          <option value="closed">Empfang bestätigt</option>
        </select>
        <clr-control-error>Statusupdate nicht vergessen!</clr-control-error>
      </clr-select-container>
      <clr-date-container>
        <label>Datum</label>
        <input clrDate type="date" placeholder="{{ transportForm.value.delivery_date | date: 'dd.MM.yyyy' }}" formControlName="delivery_date" />
      </clr-date-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" [disabled]="transportForm.get('stepI')?.invalid">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/transport/details', projectId, jobId, transportId, orderId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepII">
    <clr-step-title>Bearbeiter</clr-step-title>
    <clr-step-description>(seitens PPS)</clr-step-description>
    <clr-step-content *clrIfExpanded>
      <div>Projektnummer {{ projectId }}</div>

      <clr-radio-container clrInline>
        <clr-radio-wrapper *ngFor="let employee of staff">
          <input type="radio" clrRadio formControlName="employee_phm" [value]="employee.staff_id" />
          <label [class.leader]="employee.staff_id === projectStaff()">
            <ng-container *ngIf="employee.staff_id === projectStaff(); else defaultName">
              <b>{{ employee.firstname }} {{ employee.lastname }}</b>
            </ng-container>
            <ng-template #defaultName>{{ employee.firstname }} {{ employee.lastname }}</ng-template>
          </label>
        </clr-radio-wrapper>
      </clr-radio-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" [disabled]="transportForm.get('stepII')?.invalid">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/transport/details', projectId, jobId, transportId, orderId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepIII">
    <clr-step-title>Ansprechpartner</clr-step-title>
    <clr-step-description>(seitens Empfänger)</clr-step-description>
    <clr-step-content *clrIfExpanded>
      <select clrSelect formControlName="employee_leader">
        <option></option>
        <option *ngFor="let person of persons" value="{{ person.pid }}">{{ person.lastname }}, {{ person.firstname }}</option>
      </select>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" [disabled]="transportForm.invalid" (click)="updateTransport()">Änderungen speichern</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/transport/details', projectId, jobId, transportId, orderId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>
</form>

<pre *ngIf="devMode" class="datepicker-output">
  <p>Company: {{ companyId }}</p>
  <p>TransportForm:</p>
    {{ transportForm.value | json }}
</pre>

<pre *ngIf="devMode" class="datepicker-output">
  <p>TransportData:</p>
    {{ transportData | json }}
</pre>
